<template>
    <div class="fw-customer">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div>
            <div class="fw-customer-btn">
                <span style="color: #F9BA5F" @click="toAddMember">创建客户+</span>
                <span @click="toDelMember">已删列表</span>
                <span>客户分析</span>
            </div>
            <div class="fw-customer-mb">
                <van-search
                        v-model="money"
                        placeholder="要搜索的手机号 / 姓名"
                        shape="round"
                        style="width: 80%;margin-left: 30px"
                >
                </van-search>
                <span class="soubtn" @click="onSearch">搜索</span>
            </div>
            <div class="members">
                <div v-for="(item,index) in members" @click="toCenter(item)">
                    <el-card class="box-card" >
                        <div slot="header" class="clearfix" >
                            <div>
                                <div class="userinfo">
                                    <span>{{item.memberName}}</span>
                                    <span v-if="item.sex == 0">未知</span>
                                    <span v-if="item.sex == 1">男</span>
                                    <span v-if="item.sex == 2">女</span>
                                    <span style="font-size: 11px;line-height: 18px">({{item.phone}})</span>
                                </div>
                                <div class="ui-jb">
                                    <img src="../../assets/huizhang.png" class="ui-jb-img">
                                    <span style="padding-left: 8px">{{item.lvName==null?'未开通':item.lvName}}</span>
                                </div>
                            </div>
                            <el-button class="ui-btn" type="text">
                                <van-cell is-link @click.stop="toBtn(item,index)"></van-cell>
                            </el-button>
                        </div>
                        <div>
                            <div class="czxf-time">
                                <div class="cx-time">
                                    <span class="t" >上次充值</span>
                                    <span class="b" >{{item.czTime==null?'暂无':item.czTime}}</span>
                                </div>
                                <div class="cx-time">
                                    <span class="t" >上次消费</span>
                                    <span class="b" >{{item.xfTime==null?'暂无':item.xfTime}}</span>
                                </div>
                            </div>
                            <div class="czxf-time" style="margin-top: 25px">
                                <div class="je-val">
                                    <span class="t">预存余额(元)</span>
                                    <span class="b">¥{{item.balance}}</span>
                                </div>
                                <div class="je-val">
                                    <span class="t">赠送余额(元)</span>
                                    <span class="b">¥{{item.give}}</span>
                                </div>
                                <div class="je-val">
                                    <span class="t">红包余额(元)</span>
                                    <span class="b">¥0</span>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>
        </div>
        <van-popup v-model="mbShow" position="bottom" closeable lock-scroll overlay style="height: 100%;">
            <AddMemmber ref="addmb" @gbMember="gbMember" />
        </van-popup>
        <van-popup v-model="delShow" position="bottom" closeable lock-scroll overlay style="height: 100%;">
            <DelMemmber ref="delmb" @gbMember="gbMember" />
        </van-popup>
        <van-popup v-model="btnShow" position="bottom" closeable lock-scroll overlay style="height: 30%;">
            <div style="margin-top: 50px">
                <span class="cc-btn" style="background-color: #ee0a24;" @click="delMember">删除</span>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";
    import AddMemmber from "../common/addMember";
    import DelMemmber from "./del";
    export default {
        components: {AddMemmber,DelMemmber},
        data() {
            return {
                title: '客户中心',
                deptId: '',
                token: '',
                money: '',
                members: [],
                mbIndex:'',

                mbShow:false,
                delShow:false,
                btnShow:false,
                mb:{},
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
        },
        methods: {
            toBtn(item,index){
                this.mb=item
                this.mbIndex=index
                this.btnShow=true
            },
            toAddMember(){
                this.mbShow=true
                if (this.$refs.addmb){
                    this.$refs.addmb.chushi();
                }
            },
            toDelMember(){
                this.delShow=true
                if (this.$refs.delmb){
                    this.$refs.delmb.chushi();
                }
            },
            toCenter(item) {
                this.$router.push('/service?memberId='+item.id)
            },
            gbMember(){
                this.mbShow=false
                this.delShow=false
            },

            async onSearch() {
                if (!this.money) {
                    this.$notify("请输入要搜索的手机号 / 姓名!");
                    return;
                }
                let data = {
                    deptId: this.deptId,
                    name: this.money,
                };
                let res = await this.$get("/fw/getCustomer", data);
                if (res.code == 200) {
                    this.members = res.list;
                }
            },

           async delMember(){
               let res = await this.$post('/fw/fwDelMember', {id: this.mb.id})
               if (res.code == 200) {
                   this.closeBtn()
                   this.$notify({
                       message: res.message,
                       duration: 1000,
                       background: '#1989fa'
                   });
               } else {
                   this.$notify({
                       message: res.message,
                       duration: 1000,
                       background: 'red'
                   });
               }
            },
            closeBtn(){
                this.members.splice(this.mbIndex,1)
                this.btnShow=false
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-customer {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 49px;
        padding-bottom: 49px;
    }
    .fw-customer-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 8px;
    }
    .fw-customer-btn span{
      width: 25%;
      font-size: 15px;
      text-align: center;
      height: 32px;
      line-height: 32px;
    }

    .fw-customer-mb {
        padding: 0 8px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        justify-items: center;
        align-items: center;
    }

    .members {
        display: flex;
        flex-direction: column;
        border-top: #EEEEEE solid 1px;
        padding: 10px;
    }


    .soubtn {
        height: 34px;
        line-height: 34px;
        background-color: #F9BA5F;
        border-radius: 25px;
        width: 50px;
        font-size: 14px;
        text-align: center;
        position: relative;
        left: -40px;
    }
    .userinfo{
        font-size: 15px;
        font-weight: bold;
        display: flex;
        flex-direction: row;
    }
    .userinfo span{
        margin-right: 10px;
    }
    .ui-btn{
        float: right;
        font-size: 23px;
        height: 30px;
        position: relative;
        top:-55px;
        right: -20px;
        color: #000000;
        font-weight: bold;
    }
    .ui-jb{
        width: 100px;
        background-color: #C18DFC;
        font-size: 10px;
        padding: 0 8px;
        border-radius: 10px;
        margin-top: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #FFFFFF;
    }
    .ui-jb-img{
        width: 23px;
        height: 13px;
    }
    .czxf-time{
        display: flex;
        flex-direction: row;
        margin: 8px;
    }
    .cx-time{
        width: 50%;
    }
    .cx-time .t{
        display: block;
        color: #979797;
        font-size: 13px;
    }
    .cx-time .b{
        display: block;
        font-size: 12px;
        margin-top: 12px;
    }
    .je-val{
        width: 33.3%;
    }
    .je-val .t{
        display: block;
        color: #979797;
        font-size: 13px;
    }
    .je-val .b{
        display: block;
        font-size: 12px;
        margin-top: 12px;
    }

    /deep/ .el-card__header {
        padding: 12px 18px;
        box-sizing: border-box;
    }
    /deep/ .el-card__body {
        padding: 12px 18px;
    }
    /deep/ .van-cell--clickable {
        background-color: transparent; /* 去掉点击时的背景色 */
    }
    /deep/.van-cell:after {
        display: none; /* 去掉点击后的边框 */
    }
    .cc-btn{
        display: block;
        text-align: center;
        font-size: 15px;height: 30px;
        line-height: 30px;
        color: #ffffff;
        margin: 8px 0;
    }
    .box-card{
        margin-bottom: 8px;
    }
</style>
